export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/resume_design.d9e7dc8.svg";